<!--
 * @Author: your name
 * @Date: 2020-04-23 17:57:27
 * @LastEditTime: 2021-05-25 11:59:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\views\Wap\ProductCenter\index.vue
-->
<template>
  <div class="page-productCenter-m" @click.stop="closeShade">
    <Header-m></Header-m>
    <div class="productCenter-banner"></div>
    <div class="productCenter-describe">
      <div class="describe-item describe-item-1" @click="jump('/productDetails_m','1')">
        <div class="item-btn item-btn-pos1">查看详情</div>
      </div>
      <div class="describe-item describe-item-2" @click="jump('/productDetails_m','2')">
        <div class="item-btn item-btn-pos2">查看详情</div>
      </div>
      <div class="describe-item describe-item-3" @click="jump('/productDetails_m','3')">
        <div class="item-btn item-btn-pos1">查看详情</div>
      </div>
      <a href="tel:023-68663505" ref="tel">
        <div class="describe-item describe-item-4">
          <div class="item-btn item-btn-pos3">电话咨询</div>
        </div>
      </a>
      <a href="tel:023-68663505" ref="tel">
        <div class="describe-item describe-item-5">
          <div class="item-btn item-btn-pos4">电话咨询</div>
        </div>
      </a>
      <a href="tel:023-68663505" ref="tel">
        <div class="describe-item describe-item-6">
          <div class="item-btn item-btn-pos3">电话咨询</div>
        </div>
      </a>
      <a href="tel:023-68663505" ref="tel">
        <div class="describe-item describe-item-7">
          <div class="item-btn item-btn-pos5">电话咨询</div>
        </div>
      </a>
    </div>
    <Menu path="/productCenter_m" ref="closeShade"></Menu>
  </div>
</template>
<script>
import HeaderM from "@/components/wap/HeaderM/index.vue";
import Menu from "@/components/wap/Menu/index.vue";
import router from "@/router";
import { MessageBox } from "mint-ui";
export default {
  components: {
    HeaderM,
    Menu,
  },
  data() {
    return {};
  },
  beforeCreate() {
    require("../../../static/js/adaptation.js");
  },
  methods: {
    /**
     * 点击跳转
     */
    jump(value, type) {
      router
        .push({
          path: value,
          query: { type }
        })
        .catch(err => {
          console.log(err);
        });
    },
    open() {
      MessageBox.confirm("023-68663505", "电话咨询", {
        confirmButtonText: "拨打"
      })
        .then(() => {
          this.$refs.tel.click();
        })
        .catch(err => {
          console.log(err);
        });
    },
    closeShade() {
      this.$refs.closeShade.closeShade();
    }
  }
};
</script>
<style lang="sass">
@import "./style.scss"
</style>